import { render, staticRenderFns } from "./commentEnter.vue?vue&type=template&id=15d93185&scoped=true&lang=html&"
import script from "./commentEnter.vue?vue&type=script&lang=js&"
export * from "./commentEnter.vue?vue&type=script&lang=js&"
import style0 from "./commentEnter.vue?vue&type=style&index=0&id=15d93185&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d93185",
  null
  
)

export default component.exports